module.exports = __webpack_public_path__ + "img/img55.3dacfb06.png";